import { createContext, useReducer } from 'react';
import * as React from 'react'
import { 
  IAssessment, 
  IAssessmentProject,
  ISummaryTotalKnowledge, 
  IControlType,
  IAssessmentTemplateGroup,
  IControlMeasureCost,
  ISummaryKnowledge,
  IRiskAssessment,
  IInvestigation,
  IInvestigationAssessment,
  ISeverity,IHarm ,
  IControlMeasureAdequacy,
  IControlMeasureAssessment,
  ICriticalHazards, 
  IDam, 
  IDocument, 
  IError, 
  IFailureMode, 
  IAdequacy,
  IFailureModeAssessment, 
  IUpload, 
  IDamsList, 
  IDataGap, 
  IControlMeasure, 
  IProjectFailureMode, 
  IAssessmentTemplateDetail,
  IState,
  IControlMeasureFailureMode,
  IControlMeasureConcern,
  IConsequenceCategory,
  IAssessmentSettings,
  ICommentThread } from "../types/types";
import ControlMeasure from '../components/control_measure';
import { get, post } from "../fetchers/fetchers";




type ProviderProps = { children: React.ReactNode }

interface DataModel {
  write_access: boolean,
  access_level: number,
  loaded: boolean,
  change: number,
  // dams: IDam[],
  // assessments: IDamsList[],
  assessmentTemplates: IAssessmentTemplateDetail[],
  dataGaps: IDataGap[],
  adequacies: IAdequacy[],
  controlTypes: IControlType[],
  controlMeasureAdequacy: IControlMeasureAdequacy[],
  controlMeasureConcern: IControlMeasureConcern[],
  controlMeasureAssessments: IControlMeasureAssessment[],
  controlMeasures: IControlMeasure[],
  controlMeasureCosts: IControlMeasureCost[],
  failureModes: IProjectFailureMode[],
  failureModeControlMeasures: IControlMeasureFailureMode[],
  failureModeAssessments: IFailureModeAssessment[],
  criticalHazards: ICriticalHazards[],
  severity: ISeverity[],
  harms: IHarm[],
  investigations: IInvestigation[],
  investigationAssessments: IInvestigationAssessment[],
  criticalRiskAssessments: IRiskAssessment[],
  projectAssessment: IAssessmentProject,
  projectAssessments: IAssessment[],
  summaryKnowledge: ISummaryKnowledge[],
  templateGroups: IAssessmentTemplateGroup[],
  summaryTotalKnowledge: ISummaryTotalKnowledge,
  states: IState[], 
  consequenceCategories: IConsequenceCategory[],
  documents: IDocument[],
  commentThreads: ICommentThread[],
  assessmentSettings: IAssessmentSettings,

}

let preset = {
  write_access: false,
  access_level: 0,
  loaded: false,
  change: 0,
  dams: [],
  assessments: [],
  assessmentTemplates: [],
  dataGaps: [],
  adequacies: [],
  controlTypes: [],
  controlMeasureAdequacy: [],
  controlMeasureConcern: [],
  controlMeasureAssessments: [],
  controlMeasures: [],
  controlMeasureCosts: [],
  failureModes: [],
  failureModeControlMeasures: [],
  failureModeAssessments: [],
  criticalHazards: [],
  severity: [],
  harms: [],
  investigations: [],
  investigationAssessments: [],
  criticalRiskAssessments: [],
  projectAssessment: {name:"", is_active:true},
  projectAssessments: [],
  summaryKnowledge: [],
  templateGroups: [],
  summaryTotalKnowledge: {},
  states: [],
  consequenceCategories: [],
  documents: [],
  commentThreads: [],
  assessmentSettings: {
    name: "", 
    is_active: true, 
    type: "SFAIRP",
    assessment_project_id: 0,
    uuid: -1,
    value_of_life: 0,
    discount_rate: 0,
    total_project_years: 0,
    ancold_guideline_id: 1,
    is_failure_mode_centric: false,
    consider_societal_concerns: false,
    safety_threshold_societal: 0.001,
    safety_threshold_individual: 0.0001
    
  }

}

type Action = |{type: 'set_loaded', data: boolean}| 
{ type: 'set_data_gap', data: IDataGap[] } |
{ type: 'set_adequacies', data: IAdequacy[] } |
{ type: 'set_controlTypes', data: IControlType[] } |
{ type: 'set_controlMeasureAdequacy', data: IControlMeasureAdequacy[] } |
{ type: 'set_controlMeasureConcern', data: IControlMeasureConcern[] } |
{ type: 'set_controlMeasures', data: IControlMeasure[] } |
{ type: 'set_failureModes', data: IProjectFailureMode[] } |
{ type: 'set_failureModeControlMeasures', data: IControlMeasureFailureMode[] } |
{ type: 'set_failureModeAssessments', data: IFailureModeAssessment[] } |
{ type: 'set_controlMeasureAssessments', data: IControlMeasureAssessment[] } |
{ type: 'set_criticalHazards', data: ICriticalHazards[] } |
{ type: 'set_controlMeasureCosts', data: IControlMeasureCost[] } |
{ type: 'set_severity', data: ISeverity[] } |
{ type: 'set_harms', data: IHarm[] } |
{ type: 'set_investigations', data: IInvestigation[] } |
{ type: 'set_investigationAssessments', data: IInvestigationAssessment[] } |
{ type: 'set_criticalRiskAssessments', data: IRiskAssessment[] } |
{ type: 'set_projectAssessment', data: IAssessmentProject } |
{ type: 'set_projectAssessments', data: IAssessment[] } |
{ type: 'set_summaryKnowledge', data: ISummaryKnowledge[] } |
{ type: 'set_templateGroups', data: IAssessmentTemplateGroup[] } |
{ type: 'set_summaryTotalKnowledge', data: ISummaryTotalKnowledge } |
{ type: 'addControlMeasure', data: IControlMeasure, id: number } |
{ type: 'set_assessmentTemplates', data: IAssessmentTemplateDetail[] } | 
{ type: 'set_states', data: IState[] } |
{ type: 'set_consequenceCategories', data: IConsequenceCategory[] } |
{ type: 'set_documents', data: IDocument[] } |
{ type: 'set_access_level', data: number} |
{ type: 'set_write_access', data: boolean} |
{ type: 'set_comment_threads', data: ICommentThread[] } |
{ type: 'set_assessment_settings', data: IAssessmentSettings }



// we create one context for the state, and one for the despatch actions. Technically these
// could be combined in one context, but the React docs recommends separation for better readibility 
export const TasksContext = createContext<DataModel | undefined>(undefined);
export const TasksDispatchContext = createContext<any | undefined>(undefined);

// this componant ties the reducer and the two contexts together
export function TasksProvider({ children }: ProviderProps) {
  const [tasks, dispatch] = useReducer(dataReducer, preset);
  return (
    <TasksContext.Provider value={tasks}>
      <TasksDispatchContext.Provider value={dispatch}>
        {children}
      </TasksDispatchContext.Provider>
    </TasksContext.Provider>
  );
}


// this function defines what actions can be performed on the state via the reducer
function dataReducer(tasks: DataModel, action: Action) {

  switch (action.type) {

    case 'set_loaded': {
      return { ...tasks, loaded: action.data }
    }
    case 'set_data_gap': {
      return { ...tasks, dataGaps: action.data }
    }
    case 'set_adequacies': {
      return { ...tasks, adequacies: action.data }
    }
    case 'set_controlTypes': {
      return { ...tasks, controlTypes: action.data }
    }
    case 'set_controlMeasureAdequacy': {
      return { ...tasks, controlMeasureAdequacy: action.data }
    }
    case 'set_controlMeasureConcern': {
      return { ...tasks, controlMeasureConcern: action.data }
    }
    case 'set_controlMeasures': {
      return { ...tasks, controlMeasures: action.data }
    }
    case 'set_failureModes': {
      return { ...tasks, failureModes: action.data }
    }
    case 'set_failureModeControlMeasures': {
      return { ...tasks, failureModeControlMeasures: action.data }
    }
    case 'set_failureModeAssessments': {
      return { ...tasks, failureModeAssessments: action.data }
    }
    case 'set_controlMeasureAssessments': {
      return { ...tasks, controlMeasureAssessments: action.data }
    }
    case 'set_criticalHazards': {
      return { ...tasks, criticalHazards: action.data }
    }
    case 'set_controlMeasureCosts': {
      return { ...tasks, controlMeasureCosts: action.data }
    }
    case 'set_severity': {
      return { ...tasks, severity: action.data }
    }
    case 'set_harms': {
      return { ...tasks, harms: action.data }
    }
    case 'set_investigations': {
      return { ...tasks, investigations: action.data }
    }
    case 'set_investigationAssessments': {
      return { ...tasks, investigationAssessments: action.data }
    }
    case 'set_criticalRiskAssessments': {
      return { ...tasks, criticalRiskAssessments: action.data }
    }
    case 'set_projectAssessment': {
      return { ...tasks, projectAssessment: action.data }
    }
    case 'set_projectAssessments': {
      return { ...tasks, projectAssessments: action.data }
    }
    case 'set_summaryKnowledge': {
      return { ...tasks, summaryKnowledge: action.data }
    }
    case 'set_templateGroups': {
      return { ...tasks, templateGroups: action.data }
    }
    case 'set_summaryTotalKnowledge': {
      return { ...tasks, summaryTotalKnowledge: action.data }
    }
    case 'addControlMeasure': {

      let element = { ...tasks, controlMeasures: [...tasks.controlMeasures, action.data] }
      element.change = element.change + 1;

      return element
    }
    case 'set_assessmentTemplates': {
      return { ...tasks, assessmentTemplates: action.data }
    }
    case 'set_states': {
      return { ...tasks, states: action.data }
    }
    case 'set_consequenceCategories': {
      return { ...tasks, consequenceCategories: action.data }
    }
    case 'set_documents': {
      return { ...tasks, documents: action.data }
    }
    case 'set_access_level': {
      return { ...tasks, access_level: action.data }
    }
    case 'set_write_access': {
      return { ...tasks, write_access: action.data }
    }
    case 'set_comment_threads': {
      return { ...tasks, commentThreads: action.data }
    }
    case 'set_assessment_settings': {
      return { ...tasks, assessmentSettings: action.data }
    }
  }
}

export function useTask() {
  const context = React.useContext(TasksContext);
  if (context === undefined) {
    throw new Error('useTask must be used within a TaskProvider');
  }
  return context;
}